import { Box, styled } from '@ltvco/refresh-lib/theme';

import { StyledInputChat } from 'components/DeepSearch/components/components';
import { hideScrollbar } from 'components/DeepSearch/styleMixins';

// Keep the placeholder on one line so it doesn't wrap/clip on narrow screens.
// Scrollbar hidden so the gutter doesn't shrink the usable width once the text
// exceeds the max height (still scrolls).
export const DeepSearchInputTextarea = styled(StyledInputChat)({
  ...hideScrollbar,
  '&::placeholder': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});

// Landing: full-width row with upload button on the left and send button on
// the right (matches the landing input design).
// Chat: shrink to the button so the textarea (flex:1) keeps the rest of the row.
export const SendButtonRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLanding',
})<{ isLanding?: boolean }>(({ theme, isLanding }) => ({
  display: 'flex',
  alignItems: 'center',
  ...(isLanding
    ? {
        width: '100%',
        marginTop: theme.spacing(1),
        justifyContent: 'space-between',
      }
    : { flexShrink: 0, justifyContent: 'flex-end' }),
}));

interface AnimatedDisclaimerProps {
  visible: boolean;
}

// Disclaimer that fades in below the input on the chat-view variant.
// max-height transitions remove layout space entirely when hidden so the
// input doesn't pop on first mount.
export const AnimatedDisclaimer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'visible',
})<AnimatedDisclaimerProps>(({ theme, visible }) => ({
  display: 'block',
  fontSize: '13px',
  color: theme.palette.text.secondary,
  textAlign: 'center',
  marginTop: theme.spacing(2),
  // Visible once shown so the "Click here" popover isn't clipped (hidden while
  // collapsing in, for a clean height animation). maxHeight is generous enough
  // to fit the wrapped disclaimer text on narrow screens, so with overflow
  // visible the text doesn't spill past the box (only the popover overflows).
  overflow: visible ? 'visible' : 'hidden',
  maxHeight: visible ? '120px' : '0px',
  opacity: visible ? 1 : 0,
  transition: visible ? 'max-height 0.4s ease, opacity 0.4s ease' : 'none',
}));
